import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Actions
import { actions as authActions } from '../../ducks/auth.js';

// Components
import AuthLayout from '../../components/AuthLayout/AuthLayout.js';

class Auth extends React.Component {
  componentDidMount() {
    const { getAuthToken, authenticated } = this.props;
    getAuthToken();
  }

  render() {
    return <div />;
  }
}

const mapStateToProps = (state) => ({
  authenticated: state.auth.authenticated,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...authActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Auth);
